// Mock data for Unmapped.blr landing page

export const heroData = {
  logo: "unmapped.blr",
  phrases: [
    "Play",
    "Reimagining futures",
    "Collective Memory",
    "what is a city?",
    "unmapping bengaluru",
    "connection",
    "what is a place",
    "space"
  ],
  landmarks: [
    {
      id: 1,
      name: "Vidhana Soudha",
      imageUrl: "https://commons.wikimedia.org/wiki/Special:FilePath/Vidhana_Soudha_in_Bengaluru_8.jpg"
    },
    {
      id: 2,
      name: "Bull Temple",
      imageUrl: "https://commons.wikimedia.org/wiki/Special:FilePath/Bull_temple_Bull_at_Bangalore.jpg"
    },
    {
      id: 3,
      name: "Tipu Sultan Palace",
      imageUrl: "https://commons.wikimedia.org/wiki/Special:FilePath/Tipu_Sultan_Summer_Palace.jpg"
    },
    {
      id: 4,
      name: "Cubbon Park",
      imageUrl: "https://commons.wikimedia.org/wiki/Special:FilePath/Cubbon_Park-Bangalore.jpg"
    },
    {
      id: 5,
      name: "Lalbagh",
      imageUrl: "https://commons.wikimedia.org/wiki/Special:FilePath/Lalbagh,_Bengaluru.jpg"
    },
    {
      id: 6,
      name: "Russell Market",
      imageUrl: "https://commons.wikimedia.org/wiki/Special:FilePath/Russel_market,_Bangalore.jpeg"
    },
    {
      id: 7,
      name: "K. R. Market",
      imageUrl: "https://commons.wikimedia.org/wiki/Special:FilePath/K_R_Market_Bangalore.jpg"
    }
  ]
};

export const aboutData = {
  title: "Who are we?",
  content: `Unmapped.blr is a collective reimagining Bangalore through heritage walks, interactive games, and creative workshops. We explore the city's layers - its forgotten stories, hidden spaces, and collective memories. 

Our mission is to unmap the familiar, revealing new perspectives on what makes a city, a place, and a space. Through play and exploration, we connect communities with their urban heritage in unexpected ways.`
};

export const walksData = {
  title: "Walks",
  ideology: "We believe cities are not fixed maps but living stories. Our heritage walks don't just trace historical routes - they unmap conventional narratives, inviting participants to rediscover Bangalore through collective memory, forgotten spaces, and playful exploration.",
  locations: [
    {
      id: 1,
      name: "Sankey Tank",
      description: "We tried to understand the layered history of Bengaluru's water systems while walking around Sankey Tank. This walk was not only about the heritage of the city but also about how we imagine the future of water.",
      imageUrl: "/walks/sankey/sankey-01.jpeg",
      imageUrls: [
        "/walks/sankey/sankey-01.jpeg",
        "/walks/sankey/sankey-02.jpeg",
        "/walks/sankey/sankey-03.jpeg",
        "/walks/sankey/sankey-04.jpeg"
      ],
      position: { x: 50, y: 20 }
    },
    {
      id: 2,
      name: "MN Krishna Rao Park",
      description: "MN Krishnarao Park resides in the heart of Basavanagudi and is an intrinsic part of the lives of the people who live there. We explored the history of the area and the life of the man it was named after amongst other things.",
      imageUrl: "/walks/mn-rao/mn-rao-01.jpg",
      imageUrls: [
        "/walks/mn-rao/mn-rao-01.jpg",
        "/walks/mn-rao/mn-rao-02.jpg",
        "/walks/mn-rao/mn-rao-03.jpg",
        "/walks/mn-rao/mn-rao-04.jpg",
        "/walks/mn-rao/mn-rao-05.jpg"
      ],
      position: { x: 30, y: 65 }
    },
    {
      id: 3,
      name: "Gandhi Bazaar",
      description: "We took an experimental mapping walk around Gandhi Bazaar to map the movement and life of the market. Our goal was to understand how people use spaces and whether we can truly design for the chaos of a bustling Indian market.",
      imageUrl: "/walks/gandhi-bazaar/gandhi-01.jpeg",
      imageUrls: [
        "/walks/gandhi-bazaar/gandhi-01.jpeg",
        "/walks/gandhi-bazaar/gandhi-02.jpeg",
        "/walks/gandhi-bazaar/gandhi-03.jpeg",
        "/walks/gandhi-bazaar/gandhi-04.jpeg",
        "/walks/gandhi-bazaar/gandhi-05.jpeg"
      ],
      position: { x: 70, y: 65 }
    }
  ]
};

export const gamesData = {
  title: "Games",
  subtitle: "Explore the city through play",
  gameLink: "https://game.un-mapped.com",
  gameName: "PLAY UNMAP!"
};

export const upcomingProjectsData = {
  label: "Upcoming",
  title: "Cole's Park: A Walk In The Park",
  description: "What would public spaces look like if they were designed for woman?\n\nWe will take a walk through Coles Park to understand the role that the park plays in the life of the women that live around it, the challenges that they face living in the city and how can we imagine infrastructure that can support them.",
  dateTime: "27 June 2026 | 8 AM to 10 AM",
  location: "Coles Park",
  seats: "15",
  posterUrl: "/walks/coles-park/coles-park-poster.png",
  infoPosterUrl: "/walks/coles-park/coles-park-info.png",
  signupLink: "https://forms.gle/4CSidekzL1MiobFfA",
  signupText: "Register Now"
};

export const walkRegistrationData = {
  label: "Upcoming",
  title: "A Walk in the Park",
  descriptionIntro: "a walk for women by women",
  description: "This is an invitation for women to come and imagine a space designed for us. Share their stories and ask questions of what accessiblity in public spaces looks like for women.",
  dateTime: "28 March 2026 | 9:00 AM to 11:00 AM",
  location: "Coles Park",
  seats: "Sold Out!",
  fee: "INR 150",
  ageGroup: "Open",
  posterUrl: "/walks/women-walk/a-walk-in-the-park-info.jpeg",
  infoPosterUrl: "/walks/women-walk/a-walk-in-the-park-main.jpeg",
  signupLink: "#",
  signupText: "Register Now"
};

export const workshopsData = {
  title: "Workshops",
  description: "We conduct interactive workshops that blend heritage, creativity, and community engagement. From storytelling sessions to mapping exercises, our workshops invite participants to become active creators of urban narratives.",
  images: [
    {
      id: 1,
      url: "/workshops/sabha-workshop-01.jpeg",
      caption: "Sabha Workshop 1"
    },
    {
      id: 2,
      url: "/workshops/sabha-workshop-02.jpeg",
      caption: "Sabha Workshop 2"
    },
    {
      id: 3,
      url: "/workshops/sabha-workshop-03.jpeg",
      caption: "Sabha Workshop 3"
    },
    {
      id: 4,
      url: "/workshops/sabha-workshop-04.jpeg",
      caption: "Sabha Workshop 4"
    },
    {
      id: 5,
      url: "/workshops/sabha-workshop-05.jpeg",
      caption: "Sabha Workshop 5"
    },
    {
      id: 6,
      url: "/workshops/sabha-workshop-06.jpeg",
      caption: "Sabha Workshop 6"
    }
  ]
};

export const contactData = {
  email: "unmapped.blr@gmail.com",
  social: {
    instagram: "https://instagram.com/unmapped.blr",
    twitter: "",
    facebook: ""
  }
};


